import styled from 'styled-components';
import { greenColor } from 'js/config/style';

export default styled.div`
  color: ${greenColor};
`;
